import React from 'react';
import { Textarea } from '@this/shared/ui/inputs/textarea';
import { isMatchingTraceId } from '@this/src/util/string/string.util';
import type RoomElement from '@this/domain/room_element/room_element2';
import type OrderItem from '@this/domain/order_item2';
import { Datepicker } from '@this/shared/ui/inputs/datepicker/datepicker';
import { observer } from 'mobx-react';
import moment from 'moment';

interface Props {
  element: RoomElement;
  orderItem: OrderItem;
  classNameForModifiedField: (...path: (string | number)[]) => string;
}

const RoomElementForm = ({ element, orderItem, classNameForModifiedField }: Props) => (
  <>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('name')}`}>
        施設名
        <span className="red">（必須）</span>
      </label>
      <input
        type="text"
        value={element.name}
        onChange={e => {
          element.name = e.target.value;
        }}
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('address')}`}>
        住所
      </label>
      <input
        type="text"
        value={element.address}
        onChange={e => {
          element.address = e.target.value;
        }}
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper-item">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('startedAT')}`}>
        利用開始日時
      </label>
      <Datepicker
        value={element.startedAt?.toDate() || undefined}
        onChange={time => {
          element.startedAt = time ? moment(time) : undefined;
        }}
        type="datetime-local"
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper-item">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('endedAt')}`}>
        利用終了日時
      </label>
      <Datepicker
        value={element.endedAt?.toDate() || undefined}
        onChange={time => {
          element.endedAt = time ? moment(time) : undefined;
        }}
        type="datetime-local"
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label className={`virtual-counte-price-change-form__label ${classNameForModifiedField('remark')}`}>
        備考
      </label>
      <Textarea
        value={element.remark}
        onChange={e => {
          element.remark = e.target.value;
        }}
        rowsMin={2}
      />
    </div>
    <div className="virtual-counte-price-change-form__input-wrapper">
      <label
        className={`virtual-counte-price-change-form__label ${classNameForModifiedField('reservationNumber')}`}
      >
        予約番号
      </label>
      <input
        type="text"
        value={element.reservationNumber}
        onChange={e => {
          element.reservationNumber = e.target.value;
        }}
        style={{
          backgroundColor: isMatchingTraceId(element.reservationNumber, orderItem.traceId) ? '#ffebee' : undefined,
          borderColor: isMatchingTraceId(element.reservationNumber, orderItem.traceId) ? '#f8bbd9' : undefined
        }}
      />
    </div>
  </>
);
export default observer(RoomElementForm);
